import type { KeyValueStore } from '@reconforta/teleconsultation-core'

function storeOf(open: () => Storage): KeyValueStore | null {
  if (typeof window === 'undefined') return null
  try {
    const storage = open()
    return {
      get: (key) => storage.getItem(key),
      set: (key, value) => {
        if (value === null) storage.removeItem(key)
        else storage.setItem(key, value)
      },
    }
  } catch {
    return null
  }
}

export function safeLocalStorage(): KeyValueStore | null {
  return storeOf(() => window.localStorage)
}

export function safeSessionStorage(): KeyValueStore | null {
  return storeOf(() => window.sessionStorage)
}
